import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

// The magic-login sign-in URL carries a bearer token (`?token=...`), and the
// password-complexity flow carries one as `?accessToken=...` — strip both
// before they reach Sentry (breadcrumbs, transactions, request context).
const scrubToken = (url: string) =>
  url.replace(/([?&](?:token|accessToken)=)[^&]+/gi, '$1[Filtered]');

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_NODE_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  enableLogs: true,
  beforeBreadcrumb: breadcrumb => {
    if (typeof breadcrumb.data?.url === 'string') {
      breadcrumb.data.url = scrubToken(breadcrumb.data.url);
    }
    if (typeof breadcrumb.data?.to === 'string') {
      breadcrumb.data.to = scrubToken(breadcrumb.data.to);
    }
    if (typeof breadcrumb.data?.from === 'string') {
      breadcrumb.data.from = scrubToken(breadcrumb.data.from);
    }
    return breadcrumb;
  },
  beforeSendTransaction: event => {
    if (typeof event.transaction === 'string') {
      event.transaction = scrubToken(event.transaction);
    }
    if (event.request?.url) {
      event.request.url = scrubToken(event.request.url);
    }
    event.spans?.forEach(span => {
      const httpUrl = span.data?.['http.url'];
      if (typeof httpUrl === 'string') {
        span.data['http.url'] = scrubToken(httpUrl);
      }
    });
    return event;
  },
  beforeSend: event => {
    if (event.request?.url) {
      event.request.url = scrubToken(event.request.url);
    }
    return event;
  },
});
